import { API_Machine_NotesHistory } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { MachineNote_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { comparePrimitives, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Skeleton } from "@mui/material";
import { SnackError } from "../ViewHelpers.js";
import { append, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { sortByDescending, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { toDateAndTimeStr } from "../Locale.js";

function fetchHistory(machineId) {
    let properties_2;
    const url = API_Machine_NotesHistory(machineId);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(MachineNote_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(MachineNote_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

export function History(historyInputProps) {
    let elems_2, elems_1;
    const machineId = historyInputProps.machineId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(undefined);
    const notes = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    useEffectOnce(() => {
        const pr = fetchHistory(machineId);
        pr.then((res) => {
            if (res.tag === 1) {
                const err = res.fields[0];
                setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("MachineView.NotesUnauthorized") : (((err.fields[0].status) === 404) ? ctx.Locale.t("MachineView.NotesNotFound") : ctx.Locale.t("MachineView.NotesFetchFailed"))) : ctx.Locale.t("MachineView.NotesFetchFailed"));
            }
            else {
                patternInput[1](res.fields[0]);
            }
        });
    });
    const loadingIndicator = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
        width: 100 + "%",
        height: 100,
    }]]);
    return createElement("div", createObj(ofArray([["style", {
        padding: 5,
        width: 100 + "%",
        maxWidth: 640,
    }], (elems_2 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_1[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: ((20 + "px ") + 0) + "px",
        gap: 10 + "px ",
    }], (elems_1 = toList(delay(() => ((notes != null) ? singleton(map_1((note) => {
        let elems;
        const updated = parse(note.Updated);
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            width: 100 + "%",
            padding: 10,
            border: (((1 + "px ") + "solid") + " ") + "var(--grey)",
            borderRadius: 5,
        }], (elems = toList(delay(() => append((note.Note.trim().length === 0) ? singleton(createElement("p", {
            style: {
                fontStyle: "italic",
                fontSize: 0.8 + "rem",
                color: "#7a7a7a",
            },
            children: ctx.Locale.t("MachineView.EmptyNote"),
        })) : singleton(createElement("p", {
            style: {
                whiteSpace: "pre-wrap",
                marginTop: 0,
            },
            children: note.Note,
        })), delay(() => singleton(createElement("span", {
            style: {
                fontSize: 0.8 + "rem",
                color: "#7a7a7a",
            },
            children: `${toDateAndTimeStr(ctx.DateFnsLocale, updated)} - ${note.UpdatedBy.Email}`,
        })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, sortByDescending((y_4) => y_4.Updated, notes, {
        Compare: comparePrimitives,
    }))) : append(singleton(loadingIndicator()), delay(() => append(singleton(loadingIndicator()), delay(() => singleton(loadingIndicator())))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

